module.exports = __webpack_public_path__ + "static/other/gameGroceryBagger.4eaa0c34.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameGroceryBagger.json
// module id = 2621
// module chunks = 0